import { Links } from '@shared/constants/links';

export const areCookiesEnabled = (): boolean => {
  try {
    const testName = '__cookie_test__';
    const testValue = '1';
    document.cookie = `${testName}=${testValue}; path=/`;
    const enabled = document.cookie.indexOf(`${testName}=${testValue}`) !== -1;
    document.cookie = `${testName}=; Max-Age=0; path=/`;
    return enabled;
  } catch {
    return false;
  }
};

export const ensureCookiesEnabledOrRedirect = () => {
  if (!areCookiesEnabled()) {
    window.location.replace(Links.notSupported);
    return false;
  }
  return true;
};
